import { uuidPattern } from "@/lib/raft_generic_helper";

const MetadataEntity = () =>
  import("@/components/metadata_entities/MetadataEntity.vue");
const AddMetadataEntity = () =>
  import("@/components/metadata_entities/AddMetadataEntity.vue");
const EditMetadataEntity = () =>
  import("@/components/metadata_entities/EditMetadataEntity.vue");
const NotFound = () => import("@/components/NotFound.vue");

const routes = [
  {
    path:
      "/raft/metadata/:raft_metadata_type([a-z0-9_]+)/add/:target_bundle([a-z0-9_]+)/:target_uuid(" +
      uuidPattern +
      ")",
    component: AddMetadataEntity,
    props: (route) => ({
      redirectOnSubmit: true,
      raftMetadataType: route.params.raft_metadata_type,
      targetBundle: route.params.target_bundle,
      targetUuid: route.params.target_uuid,
    }),
  },
  {
    path:
      "/raft/metadata/:raft_metadata_type([a-z0-9_]+)/:raft_metadata_uuid(" +
      uuidPattern +
      ")/edit",
    component: EditMetadataEntity,
    props: (route) => ({
      redirectOnSubmit: true,
      raftMetadataType: route.params.raft_metadata_type,
      raftMetadataUuid: route.params.raft_metadata_uuid,
    }),
  },
  {
    path: "/raft/metadata/js/404",
    component: NotFound,
    name: "notFound",
    props: true,
  },
  {
    path: "/raft/metadata/*",
    redirect: "/raft/metadata/js/404",
    props: true,
  },
];

const globalComponents = {
  MetadataEntity,
};

export {
  routes as metadataEntityRoutes,
  globalComponents as metadataEntityGlobalComponents,
};
